import React from 'react';
import DashboardHeader from './DashboardHeader';
import Sidebar from './Sidebar';

function DashboardLayout({ children, isSidebarOpen, toggleSidebar }) {
  return (
    <div className="flex min-h-screen bg-[#FAFBFC]">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="flex flex-col flex-1">
        <DashboardHeader toggleSidebar={toggleSidebar} />
        <div className="p-6 bg-[#FAFBFC] flex-1">
          {children}
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;
